<template>
    <div
        :class="{ 'ml-auto justify-end': isOwner }"
        class="flex w-full mt-2 space-x-3 max-w-3xl"
    >
        <div
            v-if="!isOwner"
            :class="{ 'rounded-full bg-gray-300': showAvatar }"
            class="flex-shrink-0 h-10 w-10"
        >
            <span
                :data-tooltip="comment.owner.name"
                class="rounded-full h-10 w-10"
            >
                <img
                    v-if="comment.owner.avatar"
                    :src="comment.owner.avatar"
                    :alt="comment.owner.username"
                    class="rounded-full h-10 w-10"
                    referrerPolicy="no-referrer"
                />
            </span>
        </div>
        <div>
            <p
                v-if="showAvatar"
                :class="{ 'text-right': isOwner }"
                class="has-text-weight-bold pb-0.5"
            >
                {{ comment.owner.name }}
            </p>
            <div
                :class="{
                    'has-background-primary-light rounded-l-lg': isOwner,
                    'has-background-willow-brook rounded-r-lg': !isOwner,
                }"
                class="p-3 rounded-b-lg"
            >
                <div
                    :class="{ 'flex-row-reverse': !isOwner }"
                    class="flex w-full justify-between"
                >
                    <figure
                        v-if="comment.media"
                        class="image is-square w-40"
                        @click="zoomImage"
                    >
                        <img :src="comment.media.url" loading="lazy" />
                    </figure>
                    <div>
                        <article
                            v-if="comment.reply"
                            class="chat-message message is-success"
                        >
                            <div class="message-body">
                                <p
                                    class="has-text-weight-bold has-text-black pb-1"
                                >
                                    {{ comment.reply.owner.name }}
                                </p>
                                <p v-html="comment.reply.message"></p>
                                <AppURLPreview
                                    v-for="url in $options.filters.messageURLs(comment.reply.message)"
                                    :url="url"
                                    :key="url"
                                    />
                            </div>
                        </article>

                        <p
                            :class="isOwner ? 'pr-4' : 'pl-4'"
                            class="has-text-weight-medium"
                            v-html="
                                !comment.deleted
                                    ? comment.message
                                    : $t('App.comment_deleted')
                            "
                        ></p>
                        <div v-if="!comment.deleted">
                            <AppURLPreview
                                v-for="url in $options.filters.messageURLs(comment.message)"
                                :url="url"
                                :key="url"
                            />
                        </div>
                    </div>
                    <div
                        v-if="(isOwner || isAdmin) && !comment.deleted"
                        class="dropdown is-hoverable is-align-self-flex-start"
                    >
                        <span class="icon is-small dropdown-trigger mt-1">
                            <i
                                class="mdi mdi-18px mdi-dots-vertical"
                                aria-hidden="true"
                            />
                        </span>
                        <div class="dropdown-menu" role="menu">
                            <div class="dropdown-content has-text-left">
                                <a
                                    v-if="isOwner"
                                    v-t="'Folders.dropdown_option_edit'"
                                    class="dropdown-item"
                                    @click.stop.prevent="$emit('edit', comment)"
                                />
                                <a
                                    v-t="'Folders.dropdown_option_delete'"
                                    class="dropdown-item"
                                    @click.stop.prevent="
                                        $emit('delete', comment)
                                    "
                                />
                                <a
                                    v-t="'Buttons.dropdown_option_reply'"
                                    class="dropdown-item"
                                    @click.stop.prevent="
                                        $emit('reply', comment)
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    :class="{ 'justify-end': !isOwner }"
                    class="flex w-full py-2 mb-0"
                >
                    <span class="text-xs pr-1">{{
                        comment.modified | timeFormat
                    }}</span>
                    <span
                        v-if="comment.deleted"
                        v-t="'App.content_deleted'"
                        class="is-italic is-size-7"
                    ></span>
                    <span
                        v-else-if="comment.edited"
                        v-t="'App.content_edited'"
                        class="is-italic is-size-7"
                    ></span>
                </div>
            </div>
        </div>
        <div
            v-if="isOwner"
            :class="{ 'rounded-full bg-gray-300': showAvatar }"
            class="flex-shrink-0 h-10 w-10"
        ></div>
    </div>
</template>
<script>
import moment from 'moment';
import AppURLPreview from "@/components/AppURLPreview";
import getUrls from "get-urls";

export default {
    components: {
        AppURLPreview,
    },
    filters: {
        timeFormat(timestamp) {
            return moment(timestamp).format('HH:mm');
        },
        messageURLs(message) {
        return [...getUrls(message)];
        },
    },
    props: {
        dropdown: {
            type: Boolean,
            default: false,
        },
        comment: {
            type: Object,
            default: () => {
                return {};
            },
        },
        showAvatar: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return { isIntersecting: false, observer: null };
    },
    computed: {
        isOwner() {
            return this.comment.owner.owner === this.$store.getters.user.owner;
        },
        isAdmin() {
            return (
                this.$store.getters.community.accessLevel === 'administrator'
            );
        },
    },
    watch: {
        isIntersecting(newValue, oldValue) {
            //console.log("intersecting", this.comment._id);
        },
    },
    created() {
        this.observer = new IntersectionObserver(this.onElementObserved, {
            root: this.$el,
            threshold: 1.0,
        });
    },
    beforeDestroy() {
        this.observer = null;
    },
    mounted() {
        this.observer.observe(this.$el);
    },
    methods: {
        onElementObserved(entries) {
            entries.forEach(({ target, isIntersecting }) => {
                this.isIntersecting = isIntersecting;
            });
        },
        zoomImage() {
            console.log('zooming', this.comment.media.url);
            this.$viewerApi({
                images: [this.comment.media.url],
            });
        },
    },
};
</script>

<style scoped lang="css">
/deep/.mention {
    border: 1px solid #000;
    border-radius: 0.4rem;
    padding: 0.1rem 0.3rem;
    box-decoration-break: clone;
}
</style>

<style lang="sass" scoped>
@import "~viewerjs/dist/viewer.css"
</style>
